import { configureStore } from "@reduxjs/toolkit";

import breadcrumbSlice from "./breadcrumbSlice";
import subscriptionSlice from "./subscriptionSlice";
import departmentsSlice from "./departmentsSlice";
import designationsSlice from "./designationsSlice";
import groupsSlice from "./groupsSlice";
import settingsSlice from "./settingsSlice";
import userByIdSlice from "./userByIdSlice";
import usersSlice from "./usersSlice";
import workspaceByIdSlice from "./workspaceByIdSlice";
import workspaceSlice from "./workspaceSlice";
import currentAssigneesSlice from "./currentAssigneesSlice";
import sprintSlice from "./sprintSlice";
import authSclice from "./authSlice";
import holidaySlice from "./holidaysSlice";
import timesheetCountSlice from "./timesheetCountSlice";
import approvalCountSlice from "./approvalCountSlice";
import ticketCountSlice from "./tickettabCountSlice";
import leaveCountSlice from "./leaveCountSlice";
import componentsSlice from "./componentsSlice";
import { modulesSlice } from "./modulesSlice";
import { releaseSlice } from "./releaseSlice";
import { epicSlice } from "./epicSlice";
import chatSlice from "./chatSlice";
import chatUserSlice from "./chatUserSlice";
const store = configureStore({
  reducer: {
    users: usersSlice,
    groups: groupsSlice,
    departments: departmentsSlice,
    designations: designationsSlice,
    breadcrumbs: breadcrumbSlice,
    auth: authSclice,
    accountById: settingsSlice,
    userById: userByIdSlice,
    workspace: workspaceSlice,
    workspaceById: workspaceByIdSlice,
    currentAssignees: currentAssigneesSlice,
    sprints: sprintSlice,
    holidays: holidaySlice,
    ticketTabCount: ticketCountSlice,
    timesheetCount: timesheetCountSlice,
    approvalCount: approvalCountSlice,
    leaveCount: leaveCountSlice,
    components: componentsSlice,
    modules: modulesSlice,
    releases: releaseSlice,
    epics: epicSlice,
    chat: chatSlice,
    chatUser: chatUserSlice,
    subscription: subscriptionSlice
  }
});

export default store;